export default __webpack_public_path__ + "static/media/digital-fund-passcode-hq.86155f42.gif";